import { createAuthClient } from 'better-auth/react';
import { lastLoginMethodClient } from 'better-auth/client/plugins';
import { polarClient } from '@polar-sh/better-auth/client';
import { API_BASE_URL } from './api-config';

export const authClient = createAuthClient({
  baseURL: API_BASE_URL,
  plugins: [lastLoginMethodClient(), polarClient()],
});

// Export individual methods for convenience
export const {
  signIn,
  signUp,
  signOut,
  useSession,
  updateUser,
  requestPasswordReset,
  resetPassword,
  sendVerificationEmail,
} = authClient;

// Polar customer portal access
export const { customer } = authClient;
